export default "__VITE_ASSET__C_TMsN54__"